// extracted by mini-css-extract-plugin
module.exports = {"asemblies-detail-wrapper":"assemblies-detail_asemblies-detail-wrapper__16Ayw"};